import React from "react";
import { Box, Divider } from "@material-ui/core";
import globalColors from "../../../_metronic/_assets/sass/custom/globalColors.scss";
import { ReactComponent as iconPlus } from "../../assets/icons/icon-plus-green.svg";
import { SvgIcon } from "@material-ui/core";
import { Link } from "react-router-dom";
import classes from "../../pages/admin/components/AdminTitle/styles.module.scss";

export const LabelWithBackLine = (props) => {
  return (
    <Box
      className="xv-section-heading"
      display="flex"
      alignItems="center"
      boxShadow="none"
      style={{
        overflow: "hidden",
      }}
    >
      <Box className="xv-section-heading__title" flexGrow={1} boxShadow="none">
        <b style={{ whiteSpace: "nowrap", fontSize: "18px" }}>
          {props.children}
        </b>
      </Box>
      <Divider
        className="xv-section-heading__line"
        style={{
          marginBottom: "2px",
          color: "red",
          marginLeft: props.button ? "8px" : "5px",
          marginRight: props.button ? "9px" : 0,
          backgroundColor: globalColors.primaryColor3,
          height: "0.5px",
          width: props.button ? "auto" : "95%",
          flexGrow: props.button ? 100 : 0
        }}
        elevation={0}
      />
      {props.button && (
        <div
          className="xv-section-heading__action"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "140px",
            background: globalColors.primaryColor1,
            borderRadius: "5px",
            cursor: "pointer",
            padding: "2px"
          }}
          onClick={() => props.handleOpen(true)}
        >
          <p
            style={{
              color: "#fff",
              fontSize: "14px",
              fontWeight: "bold",
              cursor: "pointer",
              margin: "0 10px"
            }}
          >Adicionar</p>
          <Link
            onClick={() => props.handleOpen(true)}
            className={classes.addButton}
            style={{
              width: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "-2px"
            }}
            title={props.tooltip}
          >

            <SvgIcon
              component={iconPlus}
              alt="Cadastrar novo"
              fill="#fff"
              viewBox="0 0 16 15"
              style={{
                width: "20px",
                height: "22px",
                fill: "#fff",
                color: "#fff",
              }}
            />
          </Link>
        </div>
      )}
    </Box>
  );
};
